import React, { useEffect, useState } from 'react';
import './Ads.css';
import { apiGet } from '../api';

const BottomAd = ({ language = 'en' }) => {
  const [ad, setAd] = useState(null);

  useEffect(() => {
    let ignore = false;

    const load = async () => {
      try {
        const hash = window.location.hash || '';
        const m = hash.match(/^#\/blog\/(en|ml)\/(.+)$/);
        let selectedAd = null;
        if (m) {
          const slug = decodeURIComponent(m[2]);
          try {
            const post = await apiGet(`/api/posts/${encodeURIComponent(slug)}`, { locale: language });
            if (post?.id) {
              const resp = await apiGet('/api/ads', { locale: language, zone: 'bottom_ad', placement: 'blog_detail', postId: String(post.id), limit: 1 });
              const items = Array.isArray(resp?.items) ? resp.items : [];
              selectedAd = items[0] || null;
            }
          } catch (_e) { /* ignore */ }
        }
        if (!selectedAd) {
          const resp = await apiGet('/api/ads', { locale: language, zone: 'bottom_ad', placement: 'home', limit: 1 });
          const items = Array.isArray(resp?.items) ? resp.items : [];
          selectedAd = items[0] || null;
        }
        if (!ignore) setAd(selectedAd);
      } catch (_) {
        if (!ignore) setAd(null);
      }
    };

    load();
    const onHash = () => { load(); };
    window.addEventListener('hashchange', onHash);
    return () => { ignore = true; window.removeEventListener('hashchange', onHash); };
  }, [language]);

  return (
    <div className="ad-bottom" role="complementary" aria-label="Bottom Advertisement">
      {ad ? (
        <a href={ad.ctaUrl || '#'} target={ad.ctaUrl ? '_blank' : undefined} rel={ad.ctaUrl ? 'noopener noreferrer' : undefined} className="ad-bottom-inner">
          <img src={ad.imageUrl || 'https://via.placeholder.com/1200x240/2d5016/ffffff?text=Advertisement'} alt={ad.title || 'Advertisement'} />
          <div className="ad-bottom-content">
            {ad.adText && <span className="ad-label">{ad.adText}</span>}
            <div className="ad-bottom-title">{ad.title}</div>
            {ad.ctaText && <div className="ad-bottom-cta">{ad.ctaText}</div>}
          </div>
        </a>
      ) : (
        <div className="ad-label">Display Your ads here</div>
      )}
    </div>
  );
};

export default BottomAd;
